import { DocumentGateway } from './document-gateway.interface';

const baseUrl = 'gk/documents';
export class HttpDocumentGateway implements DocumentGateway {
  getDocumentsByProject(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/by-project/${args.projectId}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  getDocumentById(args: { documentId: string }) {
    return { url: `${baseUrl}/${args.documentId}`, method: 'GET' };
  }

  getDocumentCategories() {
    return { url: `${baseUrl}/categories`, method: 'GET' };
  }

  getStandardizeDocuments() {
    return { url: `${baseUrl}/standardized`, method: 'GET' };
  }

  getByProjectAndSlug(args: {
    projectId: string;
    slug: string;
    groupName: string;
  }) {
    return {
      url: `${baseUrl}/${args.projectId}/slug/${args.slug}`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  postDocument(args: {
    projectId: string;
    category: any;
    fileName: string;
    hiddenForCustomer: boolean;
    toBeSigned: boolean;
    isCCMI: boolean;
    fileContent: any;
    nameOnDownload?: string;
  }) {
    const documents = [
      {
        category: args.category,
        fileName: args.fileName,
        hiddenForCustomer: args.hiddenForCustomer,
        toBeSigned: args.toBeSigned,
        isCCMI: args.isCCMI,
        fileContent: args.fileContent,
        nameOnDownload: args.nameOnDownload || '',
      },
    ];
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'POST',
      data: { documents },
    };
  }

  postSingleDocumentStandardized(args: {
    projectId: string;
    documentStandardized: any;
    hiddenForCustomer: boolean;
    toBeSigned: boolean;
    fileContent: any;
    nameOnDownload?: string;
    isCustomName: boolean;
    originalFileName: string;
  }) {
    const documentsStandardized = [
      {
        documentStandardized: args.documentStandardized,
        fileContent: args.fileContent,
        toBeSigned: args.toBeSigned,
        hiddenForCustomer: args.hiddenForCustomer,
        nameOnDownload: args.nameOnDownload || '',
        isCustomName: args.isCustomName,
        originalFileName: args.originalFileName,
      },
    ];
    return {
      url: `${baseUrl}/${args.projectId}/standardized`,
      method: 'POST',
      data: { documentsStandardized },
    };
  }

  deleteDocument(args: { documentId: string }) {
    return { url: `${baseUrl}/${args.documentId}`, method: 'DELETE' };
  }

  patchDocument(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchStandardizedDocument(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/standardized`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchValidateDocument(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/validate`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchRefuseDocument(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/refuse`,
      method: 'PATCH',
      data: args.data,
    };
  }

  sendDocumentByMail(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/send`,
      method: 'POST',
      data: args.data,
    };
  }

  patchArchiveDocument(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/archive`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchSignatureExistingDoc(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/signature-existing`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchSignatureGeneratingDoc(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/signature-generating`,
      method: 'PATCH',
      data: args.data,
    };
  }

  generateDocument(args: {
    projectId: string;
    standardSlug: string;
    data: any;
  }) {
    return {
      url: `${baseUrl}/${args.projectId}/generate/${args.standardSlug}`,
      method: 'POST',
      data: args.data,
    };
  }

  getArchiveUpsells(args: {
    month: any;
    year: any;
    searchDate: any;
    groupName: string;
  }) {
    return {
      url: `${baseUrl}/archives/upsell`,
      method: 'GET',
      params: {
        month: args.month,
        year: args.year,
        searchDate: args.searchDate,
        groupName: args.groupName,
      },
    };
  }

  getArchiveUpsellsCount(args: { month: any; year: any; searchDate: any }) {
    return {
      url: `${baseUrl}/archives/upsell-count`,
      method: 'GET',
      params: {
        month: args.month,
        year: args.year,
        searchDate: args.searchDate,
      },
    };
  }
}
